import { useRouter } from 'next/router';
import React from 'react';
import { VideoEntry } from '../../../../app/components/DetailsPage/VideoEntry';

const VideoPage = () => {
    const router = useRouter();

    return <VideoEntry videoId={router.query.videoId} />;
};

export default VideoPage;
